import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe, ArrowUpRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A1128] text-slate-300">
      {/* Massive faded brand */}
      <div className="pointer-events-none select-none absolute inset-x-0 -bottom-12 flex justify-center overflow-hidden">
        <span className="font-display font-black uppercase tracking-tighter text-[18vw] leading-none text-white/[0.03] whitespace-nowrap">
          Master King Corps
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="overline mb-4 text-slate-400">// {SITE.short} · {SITE.tagline}</div>
            <h3 className="font-display font-black uppercase text-3xl md:text-4xl text-white tracking-tighter mb-6">
              Equipping the <span className="text-red-500">front line.</span>
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              {SITE.aboutShort} Director: <span className="text-white">{SITE.director}</span>.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-4 text-slate-400">Navigate</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-slate-300 hover:text-white inline-flex items-center gap-1">Home <ArrowUpRight className="w-3.5 h-3.5" /></Link></li>
              <li><Link to="/products" className="text-slate-300 hover:text-white inline-flex items-center gap-1">Equipment <ArrowUpRight className="w-3.5 h-3.5" /></Link></li>
              <li><a href="/#about" className="text-slate-300 hover:text-white inline-flex items-center gap-1">About <ArrowUpRight className="w-3.5 h-3.5" /></a></li>
              <li><a href="/#clientele" className="text-slate-300 hover:text-white inline-flex items-center gap-1">Clientele <ArrowUpRight className="w-3.5 h-3.5" /></a></li>
              <li><a href="/#contact" className="text-slate-300 hover:text-white inline-flex items-center gap-1">Contact <ArrowUpRight className="w-3.5 h-3.5" /></a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-4 text-slate-400">Operations</div>
            <ul className="space-y-4 text-sm">
              {SITE.phones.map((p, i) => (
                <li key={p} className="flex items-start gap-3 text-slate-300">
                  <Phone className="w-4 h-4 mt-1 text-red-500 shrink-0" />
                  <a href={`tel:${SITE.phonesRaw[i]}`} data-testid={`footer-phone-${i}`} className="hover:text-white">{p}</a>
                </li>
              ))}
              <li className="flex items-start gap-3 text-slate-300">
                <Mail className="w-4 h-4 mt-1 text-red-500 shrink-0" />
                <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-white break-all">{SITE.email}</a>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <Globe className="w-4 h-4 mt-1 text-red-500 shrink-0" />
                <span>{SITE.website}</span>
              </li>
              <li className="flex items-start gap-3 text-slate-300">
                <MapPin className="w-4 h-4 mt-1 text-red-500 shrink-0" />
                <span>{SITE.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs font-mono-tactical text-slate-500 tracking-widest uppercase">
            © {year} {SITE.brand} · All rights reserved
          </p>
          <p className="text-xs font-mono-tactical text-slate-500 tracking-widest uppercase">
            Made in India · Director {SITE.director}
          </p>
        </div>
      </div>
    </footer>
  );
}
